module.exports = __webpack_public_path__ + "img/7d97a9f842a0a3c43745363a9953b6ed.png";